import { useState, useCallback, ChangeEvent, Dispatch, SetStateAction } from 'react';

export type SelectState = string;
export type SetSelectState = Dispatch<SetStateAction<SelectState>>;
export type HandleChangeSelectValue = (event: Event) => void;
type Event = ChangeEvent<{
  name?: string | undefined;
  value: unknown;
}>;

export const useSelectState = (initValue: SelectState = '') => {
  const [value, setValue] = useState<SelectState>(initValue);

  const handleChangeValue: HandleChangeSelectValue = useCallback(({ target: { value: newValue } }: Event) => {
      setValue(newValue as string);
    },
    [setValue],
  );

  return [value, handleChangeValue, setValue] as const;
};
